import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Users = [
    {
      id: '01',
      image: '/rodeo-2022/ads/afcu.jpg',
      link: 'https://www.americafirst.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'America First Credit Union',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/rodeo-2022/ads/barr-aesthetics.jpg',
      link: 'https://www.barraesthetics.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Barr Aesthetics',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/rodeo-2022/ads/amg.jpg',
      link: 'https://www.amgseniormedical.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'AMG Senior Medical',
      class: 'webFormat',
    },
    {
      id: '04',
      image: '/rodeo-2022/ads/bmw.jpg',
      link: 'https://www.bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'BMW of Utah',
      class: 'webFormat',
    },
    {
      id: '05',
      image: '/rodeo-2022/ads/country-hills-eye.jpg',
      link: 'https://www.checdocs.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Country Hills Eye Center',
      class: 'webFormat',
    },
    {
      id: '06',
      image: '/rodeo-2022/ads/classical-89.jpg',
      link: 'https://www.classical89.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      id: '07',
      image: '/rodeo-2022/ads/challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      id: '08',
      image: '/rodeo-2022/ads/hamilton-park.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      id: '09',
      image: '/rodeo-2022/ads/pbs.jpg',
      link: 'https://www.pbsutah.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
    {
      id: '10',
      image: '/rodeo-2022/ads/minky.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Minky Couture',
      class: 'webFormat',
    },
    {
      id: '11',
      image: '/rodeo-2022/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      id: '12',
      image: '/rodeo-2022/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      id: '13',
      image: '/rodeo-2022/ads/regency-royale.jpg',
      link: 'http://www.regencyroyale.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Regency Royal',
      class: 'webFormat',
    },
    {
      id: '14',
      image: '/rodeo-2022/ads/utah-food-bank.jpg',
      link: 'https://www.utahfoodbank.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Utah Food Bank',
      class: 'webFormat',
    },
    {
      id: '15',
      image: '/rodeo-2022/ads/rubys-inn.jpg',
      link: 'https://rubysinn.com/millsdec22',
      alt: 'Rubys Inn',
      class: 'webFormat',
    },
    {
      id: '16',
      image: '/rodeo-2022/ads/u-first-credit.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
    {
      id: '17',
      image: '/rodeo-2022/ads/u-dept-dance.jpg',
      link: 'https://tickets.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'University of Utah Dance',
      class: 'webFormat',
    },
    {
      id: '18',
      image: '/rodeo-2022/ads/werners.jpg',
      link: 'https://wernersmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Werners',
      class: 'webFormat',
    },
    {
      id: '19',
      image: '/rodeo-2022/ads/adibs.jpg',
      link: 'https://adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Adib’s Rug Gallery',
      class: 'webFormat',
    },
    {
      id: '20',
      image: '/rodeo-2022/ads/blue-iguana.jpg',
      link: 'https://blueiguanarestaurant.net/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Blue Iguana',
      class: 'webFormat',
    },
  ];

  Users.sort((a, b) => a.alt.localeCompare(b.alt));

  return (
    <div>
      {Users.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
